module.exports = __webpack_public_path__ + "assets/f289bd05362fc17fa79ffeb6413eeffd.mp4";